

<gallery [items]="images"></gallery>
<p>Ceci pourrait vous convenir
    Ceci pourrait vous convenir</p>
